import { createContext, ReactNode, useContext, useState } from "react";
import ToastBox from "src/components/generic/Toast";

export enum ToastStatus {
    SUCCESS = "SUCCESS",
    NEUTRAL = "NEUTRAL",
    FAIL = "FAIL"
}

export type Toast = {
    status: ToastStatus;
    message: string;
}

type ToastContextType = {
    toast: Toast | null;
    setToast: (newToast: Toast) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
    const [toast, setToast] = useState<Toast | null>(null);

    const setTimedToast = (newToast: Toast) => {
        setToast(newToast);

        setTimeout(() => {
            setToast(null);
        }, 7000);
    }

    return (
        <ToastContext.Provider value={{ toast, setToast: setTimedToast }}>
            {toast && <ToastBox toast={toast} />}
            {children}
        </ToastContext.Provider>
    )
};

export const useToast = (): ToastContextType => {
    const context = useContext(ToastContext);
    if (!context) throw new Error('useAuth mist be used within a ToastProvider')
    return context;
}